/* eslint-disable */
import httpService from '../../utils/httpService';
import {
  SET_LIST_ALL_USER,
  SET_LIST_DEVICE_TO_USER,
  REMOVE_ALL_STATE,
  SET_INFO_AN_USER
} from '../mutation-types';

import mixins from '../../mixins/mixins';
import authen from '../../utils/authen';
import store from '@/store';
import router from '../../router';
import Vue from 'vue';

const initState = () => {
  return {
    $listAllUser: [],
    $listAllUserByArea: [],
    $infoAnUser: [],
    $infoAnUserByArea: [],
    $listArea: [],
    $listEvents: [],
    token: ''
  };
};

const mapDevice = {
  state: {
    $listAllUser: initState().$listAllUser,
    $listAllUserByArea: initState().$listAllUserByArea,
    $infoAnUser: initState().$infoAnUser,
    $infoAnUserByArea: initState().$infoAnUserByArea,
    token: authen.getToken(),
    $listArea: initState().$listArea,
    $listEvents: initState().$listEvents
  },

  getters: {
    $listAllUser: state => state.$listAllUser,
    $listAllUserByArea: state => state.$listAllUserByArea,
    $infoAnUser: state => state.$infoAnUser,
    $infoAnUserByArea: state => state.$infoAnUserByArea,
    $listArea: state => state.$listArea,
    $listEvents: state => state.$listEvents
  },

  mutations: {
    SET_LIST_ALL_USER_BY_AREA(state, payload) {
      state.$listAllUser.forEach(function (element) {
        let listDeviceByArea = element.listDevices.reduce((arrs, item) => {
          //console.log(item);
          let idx = arrs.findIndex(el => el.area === item.area);
          if (idx < 0) {
            let obj = {};
            obj.area = item.area;
            obj.listDevices = [item];
            obj.listDevices.sort((a, b) => (a.Device_name > b.Device_name) ? 1 : ((b.Device_name > a.Device_name) ? -1 : 0));
            arrs.push(obj);
          } else {
            arrs[idx].listDevices.push(item);
            arrs[idx].listDevices.sort((a, b) => (a.Device_name > b.Device_name) ? 1 : ((b.Device_name > a.Device_name) ? -1 : 0));
          }
          return arrs;
        }, []);
        let obj = {};
        obj.username = element.username;
        obj.permission = element.permission;

        listDeviceByArea.sort((a, b) => (a.area > b.area) ? 1 : ((b.area > a.area) ? -1 : 0));

        obj.listDeviceByArea = listDeviceByArea || {};
        state.$listAllUserByArea.push(obj);
      });
    },

    SET_INFO_AN_USER_BY_AREA(state, payload) {
      state.$infoAnUser.forEach(function (element) {
        let listDeviceByArea = element.listDevices.reduce((arrs, item) => {
          let idx = arrs.findIndex(el => el.area === item.area);
          if (idx < 0) {
            let obj = {};
            obj.area = item.area;
            obj.listDevices = [item];
            obj.listDevices.sort((a, b) => (a.Device_name > b.Device_name) ? 1 : ((b.Device_name > a.Device_name) ? -1 : 0));
            arrs.push(obj);
          } else {
            arrs[idx].listDevices.push(item);
            arrs[idx].listDevices.sort((a, b) => (a.Device_name > b.Device_name) ? 1 : ((b.Device_name > a.Device_name) ? -1 : 0));
          }
          return arrs;
        }, []);
        let obj = {};
        obj.username = element.username;
        listDeviceByArea.sort((a, b) => (a.area > b.area) ? 1 : ((b.area > a.area) ? -1 : 0));
        obj.listDeviceByArea = listDeviceByArea || {};
        state.$infoAnUserByArea.push(obj);
      });
    },

    RESET_USER_BY_AREA(state) {
      state.$listAllUserByArea = initState().$listAllUserByArea;
      state.$infoAnUserByArea = initState().$infoAnUserByArea;
    },

    [SET_LIST_ALL_USER](state, payload) {
      state.$listAllUser = Object.values(payload);
    },

    [SET_INFO_AN_USER](state, payload) {
      state.$infoAnUser = Object.values(payload);
    },

    [SET_LIST_DEVICE_TO_USER](state, payload) {
      let index = state.$listAllUser.findIndex(
        item => item.username === payload.username
      );
      state.$listAllUser[index].listDevices = [].concat(payload.result);
      // payload.isLastItem && store.commit('SET_LIST_ALL_USER_BY_AREA');
    },

    [REMOVE_ALL_STATE](state, payload) {
      state.$infoAnUser = initState().$infoAnUser;
      state.$infoAnUserByArea = initState().$infoAnUserByArea;
      state.$listAllUser = initState().$listAllUser;
      state.$listAllUserByArea = initState().$listAllUserByArea;
      state.token = initState().token;
    },

    REDIRECT_TO_LOGIN(state, payload) {
      mixins.methods.removeInfoUser();
      router.push({ name: 'login' });
    },

    setListAreaDevice(state, payload) {
      state.$listArea = initState().$listArea;
      payload
        .filter(item => item !== null)
        .forEach((item, idx) => {
          let config = {
            index: idx,
            value: item
          };
          new Vue().$set(state.$listArea, idx, config);
        });
    },

    setListEvents(state, payload) {
      if (payload.type === 'push') {
        state.$listEvents.push(...payload.data);
      } else {
        state.$listEvents = payload.data;
      }
    }
  },

  actions: {
    LOAD_LIST_ALL_USER({ commit, dispatch, state }, payload) {
      httpService.methods
        .$post('LoginAPI/Users', JSON.stringify(authen.getToken()))
        .then(async res => {
          if (typeof res === 'string') {
            commit('REDIRECT_TO_LOGIN');
          } else {
            commit(SET_LIST_ALL_USER, res);
            for (const user of state.$listAllUser) {
              // await dispatch('LOAD_ALL_DEVICE', {
              //   listDevices: user.listDevices
              // }).then(async listPromisesLoadDevice => {
              //   await Promise.all(listPromisesLoadDevice).then(result => {
              //     commit('SET_LIST_DEVICE_TO_USER', {
              //       username: user.username,
              //       result: result.filter(item => item.Device_id)
              //     });
              //   });
              // });
              await dispatch('LOAD_USER_LIST_DEVICE', {
                tokenkey: user.tokenkey
              }).then(response => {
                if (response.list_devices && response.list_devices.length) {
                  commit('SET_LIST_DEVICE_TO_USER', {
                    username: user.username,
                    result: response.list_devices.filter(item => item.Device_id)
                  });
                } else {
                  commit('SET_LIST_DEVICE_TO_USER', {
                    username: user.username,
                    result: []
                  });
                }
              });
            }
            commit('SET_LIST_ALL_USER_BY_AREA');
          }
        });
    },

    LOAD_ALL_DEVICE({ dispatch, state, commit }, payload) {
      let listPromisesLoadDevice = [];
      payload.listDevices.forEach(deviceId => {
        listPromisesLoadDevice.push(
          dispatch('LOAD_DETAIL_DEVICE', {
            deviceId: deviceId
          })
        );
      });
      return listPromisesLoadDevice;
    },

    SET_INFO_AN_USER({ dispatch, state, commit }, payload) {
      store.commit('SET_START_LOADING_MAIN_SCREEN');
      // dispatch('LOAD_ALL_DEVICE', {
      //   listDevices: JSON.parse(authen.get('qlmn_listDevices'))
      // }).then(listPromisesLoadDevice => {
      //   Promise.all(listPromisesLoadDevice)
      //     .then(result => {
      //       commit('SET_INFO_AN_USER', {
      //         0: {
      //           username: authen.get('qlmn_username'),
      //           listDevices: result.filter(item => item.Device_id)
      //         }
      //       });
      //     })
      //     .then(() => store.commit('SET_INFO_AN_USER_BY_AREA'));
      // });
      dispatch('LOAD_USER_LIST_DEVICE', { tokenkey: authen.getToken() })
        .then(response => {
          commit('SET_INFO_AN_USER', {
            0: {
              username: authen.get('qlmn_username'),
              listDevices: response.list_devices.filter(item => item.Device_id)
            }
          });
        })
        .then(() => store.commit('SET_INFO_AN_USER_BY_AREA'));
      store.commit('SET_STOP_LOADING_MAIN_SCREEN');
    },

    LOAD_DETAIL_DEVICE(state, payload) {
      return httpService.methods.$post(
        'DataAPI/ReadDeviceDetails',
        JSON.stringify({
          device_id: payload.deviceId,
          tokenkey: authen.getToken()
        })
      );
    },

    LOAD_USER_LIST_DEVICE({ dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/ReadDeviceUser',
        JSON.stringify({
          tokenkey: payload.tokenkey
        })
      ).then(res => {
        const data = res && res.data !== undefined && res.list_devices === undefined ? res.data : res;
        if (data && typeof data === 'object') {
          dispatch('natureIntegration/APPLY_READ_USER_NATURE', data, { root: true });
        }
        return data;
      });
    },

    ADD_DEVICE_USER({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/AdminAddDevice',
        JSON.stringify({
          device_id: payload.device_id,
          deviceType: payload.deviceType,
          tokenkey: payload.token,
          area: payload.area,
          username: payload.username
        })
      );
    },

    ADD_DEVICE_ADMIN({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/AddDevice',
        JSON.stringify({
          device_id: payload.device_id,
          deviceType: payload.deviceType,
          area: payload.area,
          tokenkey: payload.token
        })
      );
    },

    REMOVE_DEVICE_ADMIN({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/DeleteDevice',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: payload.tokenUser
        })
      );
    },

    REMOVE_DEVICE_USER({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/AdminDeleteDevice',
        JSON.stringify({
          device_id: payload.device_id,
          username: payload.username,
          tokenkey: payload.tokenUser
        })
      );
    },

    ADD_USER({ commit, dispatch, state }, payload) {
      return httpService.methods.$post(
        'LoginAPI/AddUsers',
        JSON.stringify({
          username: payload.username,
          password: payload.password,
          permission: payload.permission,
          tokenkey: authen.getToken()
        })
      );
    },

    CHANGE_PASSWORD_USER({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'LoginAPI/UserChangePassword',
        JSON.stringify({
          tokenKey: payload.tokenUser,
          password: payload.password,
          NewPassword: payload.NewPassword
        })
      );
    },

    REMOVE_USER({ commit, dispatch, state }, payload) {
      return httpService.methods.$post(
        'LoginAPI/DeleteUsers',
        JSON.stringify({
          tokenkey: authen.getToken(),
          username: payload.username
        })
      );
    },

    READ_SENSOR_IN_DAY({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/ReadDeviceData',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: payload.tokenUser,
          year: payload.year,
          month: payload.month,
          day: payload.day
        })
      );
    },

    READ_ONE_SENSOR_IN_DAY({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/ReadDeviceDataByDayInput',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: payload.tokenUser,
          year: payload.year,
          month: payload.month,
          day: payload.day,
          numInput: payload.numberSensor
        })
      );
    },

    CONFIG_DEVICE_ADMIN({ commit, dispatch, state }, payload) {
      console.log("CONFIG_DEVICE_ADMIN " + JSON.stringify(payload))

      return httpService.methods.$post(
        'DataAPI/DeviceChangeAdmin',
        JSON.stringify({
          device_id: payload.deviceId,
          tokenkey: authen.getToken(),
          newdevicename: payload.newName,
          deviceType: payload.deviceType,
          latitude: payload.lat,
          longitude: payload.lng,
          area: payload.area,
          stationCode : payload.stationCode,
          provinceCode: payload.provinceCode,
          constructionSymbol: payload.constructionSymbol,
          ftpEnable : payload.ftpEnable,
          ftpAddress : payload.ftpAddress,
          ftpPort : payload.ftpPort,
          ftpUser : payload.ftpUser,
          ftpPassword : payload.ftpPassword,
          ftpDirectory : payload.ftpDirectory,
          ftpAppendDatePath: !!payload.ftpAppendDatePath,
          ftpScheduleType: payload.ftpScheduleType,
          ftpIntervalMinutes: payload.ftpIntervalMinutes,
          ftpDailyTimes: payload.ftpDailyTimes,
          ftpDataFormat: payload.ftpDataFormat,
        })
      );
    },

    CONFIG_DEVICE_USER({ comit, dispatch, state }, payload) {
      console.log("CONFIG_DEVICE_USER " + JSON.stringify(payload))
      return httpService.methods.$post(
        'DataAPI/DeviceChangeUser',
        JSON.stringify({
          device_id: payload.deviceId,
          tokenkey: authen.getToken(),
          newdevicename: payload.newName,
          deviceType: payload.deviceType,
          latitude: payload.lat,
          longitude: payload.lng,
          config: payload.config,
          area: payload.area,
          stationCode : payload.stationCode,
          provinceCode: payload.provinceCode,
          constructionSymbol: payload.constructionSymbol,
          ftpEnable : payload.ftpEnable,
          ftpAddress : payload.ftpAddress,
          ftpPort : payload.ftpPort,
          ftpUser : payload.ftpUser,
          ftpPassword : payload.ftpPassword,
          ftpDirectory : payload.ftpDirectory,
          ftpAppendDatePath: !!payload.ftpAppendDatePath,
          ftpScheduleType: payload.ftpScheduleType,
          ftpIntervalMinutes: payload.ftpIntervalMinutes,
          ftpDailyTimes: payload.ftpDailyTimes,
          ftpDataFormat: payload.ftpDataFormat,
        })
      );
    },

    TEST_FTP_CONNECTION({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'FTP/TestConnection',
        JSON.stringify({
          tokenkey: authen.getToken(),
          device_id: payload.deviceId
        })
      );
    },

    LIST_FTP_DEVICE_FILES({ commit, dispatch }, payload) {
      const page = payload.page > 0 ? payload.page : 1;
      const pageSize = payload.pageSize > 0 ? Math.min(payload.pageSize, 50) : 10;
      return httpService.methods.$post(
        'FTP/ListFiles',
        JSON.stringify({
          tokenkey: authen.getToken(),
          device_id: payload.deviceId,
          ftpListPage: page,
          ftpListPageSize: pageSize,
          ftpListForceRefresh: !!payload.forceRefresh
        })
      );
    },

    DOWNLOAD_FTP_DEVICE_FILE({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'FTP/DownloadFile',
        JSON.stringify({
          tokenkey: authen.getToken(),
          device_id: payload.deviceId,
          ftpBrowseFileName: payload.fileName
        })
      );
    },

    LIST_FTP_TARGETS({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'FTP/ListFtpTargets',
        JSON.stringify({
          tokenkey: authen.getToken()
        })
      );
    },

    LOAD_FTP_HISTORY_REPORT({ commit, dispatch }, payload) {
      const page = payload.page > 0 ? payload.page : 1;
      const pageSize = payload.pageSize > 0 ? Math.min(payload.pageSize, 200) : 50;
      return httpService.methods.$post(
        'FTP/HistoryReport',
        JSON.stringify({
          tokenkey: authen.getToken(),
          device_id: payload.deviceId || '',
          ftpTargetKey: payload.ftpTargetKey || '',
          fromDate: payload.fromDate || '',
          toDate: payload.toDate || '',
          numberPage: page,
          ftpListPageSize: pageSize,
          ftpHistoryForceSyncFromFtp: !!payload.forceSyncFromFtp
        })
      );
    },

    LOAD_ALL_AREA_DEVICE({ commit, dispatch, state }, payload) {
      httpService.methods
        .$post(
          'DataAPI/ViewListAreas',
          JSON.stringify({ tokenkey: authen.getToken() })
        )
        .then(res => {
          commit('setListAreaDevice', res);
        });
    },

    LOAD_DATA_TOTAL_LOST({ commit, dispatch, state }, payload) {
      return httpService.methods.$post(
        'DataAPI/LossByHour',
        JSON.stringify({
          device_id: payload.deviceId,
          tokenKey: authen.getToken(),
          year: payload.year,
          day: payload.day,
          month: payload.month,
          numInput: payload.numInput
        })
      );
    },

    LOAD_LIST_EVENTS({ commit, dispatch }, payload) {
      console.log(authen.get("qlmn_username"));
      httpService.methods
        .$post(
          'DataAPI/EventLoad',
          JSON.stringify({ tokenkey: authen.getToken() })
        )
        .then(res => {
          let filteredEvents = res;

          // Kiểm tra nếu username không phải 'Vĩnh Phúc 1', không áp dụng filter
          if (authen.get("qlmn_username") === 'Vĩnh Phúc 1') {
            filteredEvents = res.filter(event => !event.includes("mất kết nối"));
          }

          commit('setListEvents', { type: 'new', data: filteredEvents });
        });
    },

      GET_EVENT_NEWEST({ commit, dispatch }) {
        return httpService.methods.$post(
          'DataAPI/EventLive',
          JSON.stringify({ tokenkey: authen.getToken() })
        )
        .then(res => {
          let filteredEvents = res;

          // Kiểm tra nếu username là 'Vĩnh Phúc 1', thực hiện filter
          if (authen.get("qlmn_username") === 'Vĩnh Phúc 1') {
            filteredEvents = res.filter(event => !event.includes("mất kết nối"));
          }

          return filteredEvents;
        })
      },

    ADMIN_RESET_PASSWORD_USER({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'LoginAPI/AdminResetPassword',
        JSON.stringify({
          tokenkey: authen.getToken(),
          username: payload.username,
          newpassword: payload.newpassword
        })
      );
    },

    SET_WARNING_EMAILS({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/setemail',
        JSON.stringify(payload)
      );
    },

    GET_WARNING_EMAILS({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/getemail',
        JSON.stringify(payload)
      );
    },

    SEND_REQ_GET_SIM_INFO({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/checkSimInfo',
        JSON.stringify({
          tokenkey: authen.getToken(),
          device_id: payload.deviceId
        })
      );
    },

    RECEIVE_SIM_INFO({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/SimInfo',
        JSON.stringify({
          tokenkey: authen.getToken(),
          device_id: payload.deviceId
        })
      );
    },

    FILTER_EVENT_BY_RANGETIME({ commit, dispatch }, payload) {
      return httpService.methods.$post(
        'DataAPI/findlog',
        JSON.stringify({
          tokenkey: authen.getToken(),
          year: payload.year,
          end_day: payload.end_day,
          end_month: payload.end_month,
          start_day: payload.start_day,
          start_month: payload.start_month,
          numberPage: payload.numberPage
        })
      )
      .then(res => {
        let filteredEvents = res;

        // Kiểm tra nếu username là 'Vĩnh Phúc 1', thực hiện filter
        if (authen.get("qlmn_username") === 'Vĩnh Phúc 1') {
          filteredEvents = res.filter(event => !event.includes("mất kết nối"));
        }

        return filteredEvents;
      })
    },
    SEND_REMOTE_SETTING(state, payload) {
      return httpService.methods.$post(
        'DataAPI/sendRemoteSetting',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: authen.getToken(),
          remoteSetting: payload.remoteSetting
        })
      );
    },
    REMOTE_SETTING(state, payload) {
      return httpService.methods.$post(
        'DataAPI/remoteSetting',
        JSON.stringify({
          device_id: payload.device_id,
          tokenkey: authen.getToken()
        })
      );
    },
    READ_NOTE_REMOTE_SETTING() {
      return httpService.methods.$post(
        'DataAPI/readGuideRemoteSetting',
        JSON.stringify({
          tokenkey: authen.getToken()
        })
      );
    },
    LIST_CHILD_USERS() {
      return httpService.methods.$post(
        'LoginAPI/ListChildUsers',
        JSON.stringify(authen.getToken())
      );
    },
    ADD_CHILD_USER(state, payload) {
      return httpService.methods.$post(
        'LoginAPI/AddChildUser',
        JSON.stringify({
          username: payload.username,
          password: payload.password,
          tokenkey: authen.getToken()
        })
      );
    },
    DELETE_CHILD_USER(state, payload) {
      return httpService.methods.$post(
        'LoginAPI/DeleteChildUser',
        JSON.stringify({
          username: payload.username,
          tokenkey: authen.getToken()
        })
      );
    },
    RESET_CHILD_PASSWORD(state, payload) {
      return httpService.methods.$post(
        'LoginAPI/ResetChildPassword',
        JSON.stringify({
          username: payload.username,
          newpassword: payload.newpassword,
          tokenkey: authen.getToken()
        })
      );
    },
  }
};

export default mapDevice;



// WEBPACK FOOTER //
// ./src/store/modules/mapDevice.js